import { iconSwitchTransition as o } from "../../../../_styles/transitions/icon-switch.cssr.js";
import { cB as t, c as r, cE as e } from "../../../../_utils/cssr/index.js";
const i = t("base-clear", `
 flex-shrink: 0;
 height: 1em;
 width: 1em;
 position: relative;
`, [r(">", [e("clear", `
 font-size: var(--n-clear-size);
 height: 1em;
 width: 1em;
 cursor: pointer;
 color: var(--n-clear-color);
 transition: color .3s var(--n-bezier);
 display: flex;
 `, [r("&:hover", `
 color: var(--n-clear-color-hover)!important;
 `), r("&:active", `
 color: var(--n-clear-color-pressed)!important;
 `)]), e("placeholder", `
 display: flex;
 `), e("clear, placeholder", `
 position: absolute;
 left: 50%;
 top: 50%;
 transform: translateX(-50%) translateY(-50%);
 `, [o({
  originalTransform: "translateX(-50%) translateY(-50%)",
  left: "50%",
  top: "50%"
})])])]);
export {
  i as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/_internal/clear/src/styles/index.cssr.js
// module id = 1579
// module chunks = 67